import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import RoleProtectedRoute from "../../router/RoleProtectedRoute";
import TeamLayout from "./TeamLayout";
import TeamOwnersGuard from "./TeamOwnersGuard";
import { MENU, TEAM_BASE, teamDefaultRoute } from "./config";

// Construye el árbol de rutas /team desde la config de navegación, de
// modo que el sub-menú y las rutas nunca diverjan. Espeja los bloques de rutas
// de las otras mini-apps (una app, sub-menú plano) envuelto en
// RoleProtectedRoute.
const children: RouteObject[] = [
  { index: true, element: <Navigate to={teamDefaultRoute} replace /> },
  ...MENU.map((item) => ({ path: item.id, element: item.element })),
];

export const teamRoute: RouteObject = {
  path: TEAM_BASE,
  element: <RoleProtectedRoute restrictedRoles={["web_services"]} />,
  children: [
    {
      // #1145: en CC-CONSOLE Equipo es solo de los dueños (Isaías y Daniel).
      element: <TeamOwnersGuard />,
      children: [
        {
          path: "",
          element: <TeamLayout />,
          children,
        },
      ],
    },
  ],
};
